export default __webpack_public_path__ + "static/media/profile_photo.388775b6.svg";